import React, { FC, useCallback } from 'react';
import styled from 'styled-components';
import { LogoLeftPanel } from 'src/common/images/LogoLeftPanel';
import { HomepageRoute } from 'src/public/publicRoutes';
import { colors } from 'src/config/colors';
import { Button } from 'src/common/components/Button';
import { useDispatch, useSelector } from 'react-redux';
import { courseListingActions } from 'src/state/courseListing/courseListingActions';
import { CourseListingCategoryFilter } from 'src/public/components/course-listing/CourseListingCategoryFilter';
import { CourseListingCourseLevelFilter } from 'src/public/components/course-listing/CourseListingCourseLevelFilter';
import { CourseListingSpeakerFilter } from 'src/public/components/course-listing/CourseListingSpeakerFilter';
import { GatsbyLink } from 'src/common/migration/GatsbyLink';
import { PartnerLogoDesktop } from 'src/common/components/PartnerLogoDesktop';
import { courseListingViewType } from 'src/state/courseListing/courseListingSelectors';
import { CourseViewType } from 'src/state/courseListing/courseListingReducer';

const ClearFilters = styled(Button)`
  color: ${colors.blue07};
  font-size: 0.625rem;
  font-weight: 300;
  line-height: 0.875rem;
`;

const Container = styled.div`
  width: 100%;
`;

const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
  padding: 0 1.875rem 0 2.125rem;
`;

const Title = styled.div`
  color: ${colors.pfp3bis};
  font-weight: 600;
  letter-spacing: 0.15em;
  text-transform: uppercase;
`;

const StyledLink = styled(GatsbyLink)`
  display: inline-block;
  margin: 2.375rem 0 1.5625rem 2.125rem;
`;

export const CourseListingFilters: FC = () => {
  const dispatch = useDispatch();

  const selectedViewType = useSelector(courseListingViewType);

  const handleClearFilters = useCallback(
    () => dispatch(courseListingActions.clearFilters()),
    [dispatch],
  );

  return (
    <Container>
      <StyledLink to={HomepageRoute}>
        <LogoLeftPanel />
      </StyledLink>

      <PartnerLogoDesktop />

      <Header>
        <Title>FILTRY</Title>
        <ClearFilters decoration="underline" kind="link" onClick={handleClearFilters}>
          Wyczyść filtry
        </ClearFilters>
      </Header>

      {selectedViewType !== CourseViewType.CourseBundle && (
        <>
          <CourseListingCategoryFilter />
          <CourseListingCourseLevelFilter />
        </>
      )}
      <CourseListingSpeakerFilter />
    </Container>
  );
};
